import { ShiftFillRate } from '@/core/helpers/shiftFillRates.helper';
import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { Shift } from './shift.interface';
import shiftService from './shift.service';

export interface ShiftState {
   shifts: Array<Shift>;
   date_between?: string;
   fill_rates?: any;
   original_shifts?: Array<Shift>;
}

const ShiftStore: Module<ShiftState, StoreState> = {
   namespaced: true,
   state: {
      date_between: undefined,
   },

   getters: {},

   mutations: {
      setShifts(state, shifts) {
         state.shifts = shifts;
      },
      setDateBetween(state, { start_date, end_date }: { start_date: string; end_date: string }) {
         const date_between = `${start_date},${end_date}`;
         state.date_between = date_between;
      },
      addShiftsToShifts(state, shifts: Array<Shift>) {
         state.shifts = ([] as Array<Shift>).concat.apply([], [state.shifts, shifts]);
      },
      setShiftFillRate(
         state,
         {
            shift_id,
            shift_slots_counts,
            shift_fill_rates,
         }: {
            shift_id: number;
            shift_slots_counts: {
               at_least_planning_confirmation_puzzle_slots_count: number;
               at_least_planning_confirmation_approved_slots_count: number;
            };
            shift_fill_rates?: Array<ShiftFillRate>;
         },
      ) {
         const shift = state.shifts?.find((shift) => shift?.id === shift_id);

         if (!shift) return;
         shift.slots_counts = shift_slots_counts;
         shift.shift_fill_rates = shift_fill_rates;
      },
   },

   actions: {
      async getFillRates(
         context,
         {
            shift_ids,
            fill_rate_type,
            date_between,
            page = 1,
            per_page = 40,
            view,
         }: { shift_ids: Array<number>; fill_rate_type: string; date_between: string; page: number; per_page: number; view: string },
      ) {
         return await shiftService.getFillRates(shift_ids, fill_rate_type, date_between, page, per_page);
      },
      async postBulk(context, body: Array<Shift>) {
         return await shiftService.postBulk(body);
      },
      async putBulk(context, body: Array<Shift>) {
         return await shiftService.putBulk(body);
      },
      async deleteBulk(context, body: Shift) {
         return await shiftService.deleteBulk(body).then((response) => {
            return response;
         });
      },
   },
};

export default ShiftStore;
